<template>
	<div
		class="
			c-block-list-info-boxes-custom
			grid grid-cols-1
			gap-y-25
			mb-80
			>=768:mb-120
			>=1280:grid >=1280:grid-cols-2 >=1280:gap-x-50
		"
	>
		<button
			v-for="(box, i) in items"
			:key="i"
			v-tracking="`InfoBox, Click, ${box.content.title} - ${getPath}`"
			class="
				group
				w-full
				block
				bg-white
				rounded-8
				overflow-hidden
				>=768:p-25
				gap-25
				text-left
				items-center
				>=768:mb-0 >=768:flex
			"
			@click="onShow(i)"
		>
			<div
				v-if="box.content.image"
				class=">=768:rounded-8 overflow-hidden block min-w-165 grow-0"
			>
				<UmbracoImageExt
					class="block w-full"
					:alt="box.content.image.altText"
					:source-url="
						box.content.image.cropUrl || box.content.image.path
					"
					:source-width="box.content.image.width"
					:source-height="box.content.image.height"
					:widths="[165, 320, 417, 695]"
					sizes="(max-width: 768px) 100vw, 165px"
					:aspect-ratio="1 / 1"
				/>
			</div>
			<div class="<768:p-25">
				<h3
					v-if="box.content.title"
					class="
						flex
						items-center
						text-20
						font-bold
						uppercase
						mb-10
						leading-initial
						>=768:text-24
					"
				>
					<span v-html="box.content.title"></span>
					<span
						class="
							relative
							flex
							items-center
							w-32
							h-32
							flex-shrink-0 flex-grow-0
							rounded-full
							ml-15
							group-hover:bg-blue group-hover:text-white
						"
					>
						<SvgLinkCaret
							class="w-8 h-12 absolute left-13 right-11"
						/>
					</span>
				</h3>
				<p
					v-if="box.content.teaser"
					class="leading-editorial"
					v-html="box.content.teaser"
				></p>
			</div>
		</button>
		<Portal v-if="isOpen" to="SpaOverlay">
			<div
				class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-30"
				@click="onClose(index)"
			>
				<div
					class="
						fixed
						top-0
						right-0
						w-full
						h-full
						bg-white
						z-20
						>=768:rounded-l-8 >=768:w-half
					"
					@click.stop
				>
					<button
						class="
							absolute
							top-30
							right-20
							>=768:top-33 >=768:right-33
							rounded-full
							bg-blue
							text-white
							z-20
							w-48
							h-48
							flex
							justify-center
							items-center
							transform
							hover:rotate-180
							transition
							duration-500
							ease-in-out
						"
						@click="onClose(index)"
					>
						<SvgClose class="w-12 h-12" />
					</button>
					<div
						class="
							overflow-y-auto
							h-full
							py-100
							px-16
							>=768:py-130 >=768:px-100
						"
					>
						<div
							v-if="items[index].content.title"
							class="
								flex
								items-center
								text-32
								font-bold
								uppercase
								mb-20
								>=768:text-32
							"
						>
							<h2 v-html="items[index].content.title"></h2>
						</div>
						<div
							v-if="items[index].content.image"
							:class="[
								'rounded-8 overflow-hidden block min-w-165 grow-0 mb-20',
							]"
						>
							<UmbracoImageExt
								:alt="items[index].content.image.altText"
								:source-url="
									items[index].content.image.cropUrl ||
									items[index].content.image.path
								"
								:source-width="items[index].content.image.width"
								:source-height="
									items[index].content.image.height
								"
								:widths="[320, 417, 768]"
								:aspect-ratio="16 / 9"
							/>
						</div>
						<div
							v-if="items[index].content.text"
							class="rte"
							v-html="items[index].content.text"
						></div>
						<BlockList
							v-if="
								items[index].content.overlayContentElements &&
								items[index].content.overlayContentElements
									.length
							"
							:block-list="
								items[index].content.overlayContentElements
							"
							:fromoverlay="true"
						/>
						<NuxtLinkExtVue
							v-if="items[index].content.link"
							:key="items[index].content.link.id"
							:to="items[index].content.link.url"
							:target="items[index].content.link.target"
							class="
								text-white
								bg-blue
								rounded-full
								px-25
								py-15
								inline-block
								mt-25
								>=768:mt-50
							"
							v-html="items[index].content.link.name"
						></NuxtLinkExtVue>
					</div>
				</div>
			</div>
		</Portal>
		<CrawlerOnly>
			<section>
				<ul>
					<li v-for="(box, i) in items" :key="i">
						<h2
							v-if="box.content.title"
							v-html="box.content.title"
						></h2>
						<span v-if="box.content.image">{{
							box.content.image.altText
						}}</span>
						<p
							v-if="box.content.teaser"
							v-html="box.content.teaser"
						></p>

						<div
							v-if="box.content.text"
							v-html="box.content.text"
						></div>
						<a
							v-if="box.content.link"
							:href="box.content.link.url"
							:target="box.content.link.target"
							v-html="box.content.link.name"
						></a>
					</li>
				</ul>
			</section>
		</CrawlerOnly>
	</div>
</template>

<script>
import UmbracoImageExt from '~/components/main/UmbracoImageExt';
import SvgLinkCaret from '~/assets/svgs/link-caret.svg?inline';
import SvgClose from '~/assets/svgs/close.svg?inline';
import NuxtLinkExtVue from '~/citi-baseline/components/NuxtLinkExt.vue';
import BlockList from '~/components/main/BlockList';
import CrawlerOnly from '~/components/main/CrawlerOnly';

export default {
	name: 'BlockListInfoBoxesCustom',

	components: {
		UmbracoImageExt,
		CrawlerOnly,
		SvgClose,
		SvgLinkCaret,
		NuxtLinkExtVue,
		BlockList,
	},

	inheritAttrs: false,

	props: {
		items: Array,
	},

	data() {
		return {
			isOpen: false,
			index: 0,
		};
	},

	computed: {
		count() {
			return (this?.areaCases).length;
		},
		getPath() {
			return this.$store.state.route.fullPath;
		},
	},

	created() {
		this.$on('overlay.close', this.onClose);
	},

	methods: {
		onClose() {
			this.isOpen = false;
		},
		onShow(index) {
			this.index = index;
			this.isOpen = true;
		},
		isOdd(count) {
			return count % 2;
		},
	},
};
</script>
<style lang="postcss">
.c-block-list-info-boxes-custom a h3 svg,
.c-block-list-info-boxes-custom a img {
	transition: all 0.25s ease-in-out;
}
.c-block-list-info-boxes-custom a:hover h3 svg {
	margin-left: 15px !important;
}

.c-block-list-info-boxes-custom a:hover img {
	transform: scale(1.1);
}
</style>
